import {
  ADD_NEWTMS_FAILED,
  ADD_NEWTMS_LOADING,
  ADD_NEWTMS_SUCCESS,
  GET_ALLTMS_REMOVE,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  Tms: null,
  status: null,
};

export const addTmsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case ADD_NEWTMS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_NEWTMS_SUCCESS:
      return {
        ...state,
        loading: false,
        Tms: action.payload,
        status: action.status,
        error: null,
      };
    case ADD_NEWTMS_FAILED:
      return {
        ...state,
        loading: false,
        Tms: null,
        status: null,
        error: action.error,
      };
    case GET_ALLTMS_REMOVE:
      return initialState;
    default:
      return state;
  }
};
